import {getStartOfMonth} from "../../../common/utils"

const mapReceivableDataToReceivableMainCardUi = (
    receivableData ={},
    selectedOption={},
    onClickDownloadStatment = () => {console.log("Downloading");},
) =>{

    const {paidByDate, openingBalance,totalAmount, netWeddingzServiceFee, pastBookingsImpact, reconPaymentSection} = receivableData
    
    return !(receivableData && openingBalance && totalAmount && netWeddingzServiceFee && pastBookingsImpact && reconPaymentSection) ? {} :{
        data: {
            topSection : {
                topLeft: `Total	(A + B + C + D)`,
                // bottomLeft: `(To be paid by Weddingz.in as on ${paidByDate})`,
                topRight: totalAmount,
            },
            bodySection: {
                itemList: [
                    {
                        key: `(A) Opening balance as on ${getStartOfMonth({
                            month: selectedOption.id -1 ,
                            format: "DD MMMM yyyy"})}`,
                        value: openingBalance,
                    },
                    {
                        key: `(B) Net Wz Fee - ${selectedOption.name}`,
                        value: netWeddingzServiceFee,
                    },
                    {
                        key: `(C) Cancellation/Modification-past bookings`,
                        value: pastBookingsImpact,
                    },
                    {
                        key: `(D) Payments - ${selectedOption.name}`,
                        value: reconPaymentSection,
                    }
                ]
            },
            onClickDownloadStatment,

        },
    }
}


export default mapReceivableDataToReceivableMainCardUi
